import {Button, Divider, Flex, Heading, Icon} from "@aws-amplify/ui-react";
import React from "react";
import {Dialog} from "@mui/material";
import EiaCard from "../cards/EiaCard";
import EiaThemeProvider from "../EiaThemeProvider";
import {COLOR_TEAL} from "../../commons/enums/ColorEnums";
import {RiCloseFill} from "react-icons/ri";

const dialogStyles = {
    border: '2px solid ' + COLOR_TEAL,
};

const EiaDialog = function (props) {
    const {onClose, open, title, isLoading, maxWidth, fullWidth, helpButton} = props;

    return (
        <Dialog open={open} maxWidth={maxWidth} fullWidth={fullWidth}>
            <EiaThemeProvider>
                <div style={dialogStyles}>
                    <EiaCard>
                        {
                            title ?
                                <div>
                                    <Flex direction="row" justifyContent={"space-between"}>
                                        <EiaCard>
                                            <Heading level={3}>{title}</Heading>
                                        </EiaCard>
                                        <Flex direction="row">
                                            {helpButton ? helpButton : null}
                                            <Button size={"large"} variation={"link"} onClick={onClose} disabled={isLoading}>
                                                <Icon ariaLabel="Javascript" as={RiCloseFill}/>
                                            </Button>
                                        </Flex>
                                    </Flex>
                                    <Divider/>
                                </div> :
                                <div>
                                    <Flex direction="row" justifyContent={"flex-end"}>
                                        <Button size={"large"} variation={"link"} onClick={onClose} disabled={isLoading}>
                                            <Icon ariaLabel="Javascript" as={RiCloseFill}/>
                                        </Button>
                                    </Flex>
                                    <Divider/>
                                </div>
                        }
                        <EiaCard>
                            <Flex direction={"column"}>
                                {props.children}
                            </Flex>
                        </EiaCard>
                    </EiaCard>
                </div>
            </EiaThemeProvider>
        </Dialog>
    );
};
export default EiaDialog;